import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatDatePipe' })
export class FormatDatePipe implements PipeTransform {
  transform(date: string): any {
    if(date) {
      var fullDate = new Date(date);
      var year = fullDate.getFullYear();
      var month = (fullDate.getMonth() + 1) < 10 ? "0" + (fullDate.getMonth() + 1) : (fullDate.getMonth() + 1);
      var dt = (fullDate.getDate()) < 10 ? "0" + fullDate.getDate() : fullDate.getDate();
      return year + "/" + month + "/" + dt;
    }
    return "";
  }
}
